import ls from 'local-storage';

// https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#Feature-detecting_localStorage
function storageAvailable(type) {
  const x = '__storage_test__';
  let storage;
  try {
    storage = window[type];
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return (
      e instanceof DOMException &&
      // everything except Firefox
      (e.code === 22 ||
        // Firefox
        e.code === 1014 ||
        // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' ||
        // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
      // acknowledge QuotaExceededError only if there's something already stored
      storage &&
      storage.length !== 0
    );
  }
}

const lsProxy =
  fn =>
  (...args) =>
    !storageAvailable('localStorage') ? false : fn(...args);

// this storage interface is meant to simplify interacting with an
// angular library for local storage
const ngsUserKey = userId => `ngStorage-user${userId}`;
const ngsReadKey = (key, fallback = {}) => {
  if (!storageAvailable('localStorage')) return fallback;
  return ls.get(key) ?? fallback;
};
const ngsWriteKey = (key, val) => {
  if (!storageAvailable('localStorage')) return false;
  return ls.set(key, val);
};

export const fetchStorageForUser = userId => ngsReadKey(ngsUserKey(userId));
export const overwriteStorageForUser = (userId, newUserStorage) => ngsWriteKey(ngsUserKey(userId), newUserStorage);
export const setKeyForUser = (userId, key, value) => {
  const userKey = ngsUserKey(userId);
  const storage = ngsReadKey(userKey);
  return ngsWriteKey(userKey, { ...(storage || {}), [key]: value });
};
export const getKeyForUser = (userId, key, fallback) => {
  const userKey = ngsUserKey(userId);
  const storage = ngsReadKey(userKey);
  return storage[key] || fallback;
};
export default {
  get: ngsReadKey,
  set: ngsWriteKey,
  remove: lsProxy(ls.remove),
  on: lsProxy(ls.on),
  off: lsProxy(ls.off),
  clear: lsProxy(ls.clear),
  backend: lsProxy(ls.backend),
};
